import { render, staticRenderFns } from "./ReceiveOperationComponent.vue?vue&type=template&id=20481481&"
import script from "./ReceiveOperationComponent.vue?vue&type=script&lang=js&"
export * from "./ReceiveOperationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports